import { render, staticRenderFns } from "./RolesByEntityFullDetails.vue?vue&type=template&id=58beb69d"
import script from "./RolesByEntityFullDetails.vue?vue&type=script&lang=js"
export * from "./RolesByEntityFullDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports